import { action, makeObservable } from 'mobx';

import { FiltersSelectionState } from '../../../catalog/CatalogFiltersState';
import { FilterData, type PropertyData } from '../../../data/model';
import ColorFacetFilterState from './FabricFacetFiltersDropdowns/ColorFacetFilter/ColorFacetFilterState';
import FabricFacetFiltersModalState from './FabricFacetFiltersModal/FabricFacetFiltersModalState';
import FacetFilterState from './FacetFilterState';

export default class FabricFacetFiltersState {
  public readonly filters: FacetFilterState[];
  public readonly modal: FabricFacetFiltersModalState;
  public readonly selection = new FiltersSelectionState();

  public get appliedFilters() {
    return this.filters.filter((x) => x.selectedCount > 0);
  }

  public constructor(filters: FilterData[]) {
    makeObservable(this);

    this.filters = this.initializeFilters(filters, this.selection);

    const modalFiltersSelection = new FiltersSelectionState();
    this.modal = new FabricFacetFiltersModalState(
      this.initializeFilters(filters, modalFiltersSelection),
      modalFiltersSelection,
      this.applyFilters,
    );
  }

  @action.bound
  public applyFilters(properties: PropertyData[]) {
    this.selection.properties = [...properties];
  }

  private initializeFilters(filters: FilterData[], selection: FiltersSelectionState): FacetFilterState[] {
    return filters.map((filterData) => {
      if (filterData.isColorFilter) {
        return new ColorFacetFilterState(filterData, selection);
      }

      return new FacetFilterState(filterData, selection);
    });
  }
}
